import state from './booking.state'
import mutations from './booking.mutations'
import actions from './booking.actions'
import getters from './booking.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
